import { PHASE, timeoutOtpVerification } from './constants'

export default {
  phoneNumber: '',
  currentPhase: PHASE.VERIFY_PHONE_NUMBER,
  otp: [null, null, null, null],
  timeRemaining: timeoutOtpVerification
}
